export const environment = {
  API_URL: 'https://zb6bz0trx1.execute-api.eu-central-1.amazonaws.com',
  useMock: false,
};
